export const APP_TOAST_EVENT = 'app-toast';

export interface AppToastDetail {
  message: string;
}

export function showToast(message: string): void {
  window.dispatchEvent(
    new CustomEvent<AppToastDetail>(APP_TOAST_EVENT, { detail: { message } }),
  );
}
